module.exports = __webpack_public_path__ + "img/arrow.10ca68b2.svg";